export default __webpack_public_path__ + "static/Entenda0084-2ca564b5576642c0535aa35944755512.jpg";